import * as types from '@/store/types'
import axios from 'axios'
import constConf from '../../../constconf'
import actionRequests from './actionRequests'
export default {
    ...actionRequests,
    loadBots: (context) => {
        axios.defaults.withCredentials = true
        axios.get(constConf.bot.url + '/bot/all').then(response => {
            let bots = response.data.ok ? response.data.response.data : []
            context.commit('botAll', bots)
            // eslint-disable-next-line handle-callback-err
        }).catch((error) => {
            console.log('error get bots ' + error)
        })
    },
    saveBot: (context, payload) => {
        let method = 'post'
        let url = constConf.bot.url + '/bot/create'
        if (payload.id != null) {
            method = 'put'
            url = constConf.bot.url + '/bot/update/' + payload.id
        }
        let newModel = Object.assign({}, payload)
        axios.defaults.withCredentials = true
        if (newModel.token_vk == 1 || newModel.token_vk == 0) {
            delete newModel.token_vk
        }
        if (newModel.token_vk_mailing == 1 || newModel.token_vk_mailing == 0) {
            delete newModel.token_vk_mailing
        }
        return axios({
            method: method,
            url: url,
            data: newModel
        })
            .then((response) => {
                if (method === 'put') {
                    if (response.data.ok) { context.commit('setBot', response.data.response.data) }
                } else if (response.data.ok) {
                    context.commit('addBot', response.data.response.data)
                }
                return response.data // рабочий пример возврата данных
            })
            .catch((error) => {
                console.log('ошибка при записи модели bot')
                console.log(error)
                return null
            })
    },
    removeBot: (context, index) => {
        axios.defaults.withCredentials = true
        return axios.delete(constConf.bot.url + '/bot/remove/' + context.state.bots[index].id).then(response => {
            let bot = Object.assign({}, context.state.bots[index])
            context.commit('removeBot', context.state.bots[index].id)
            return { data: { success: { text: 'Бот: ' + bot.title + ' успешно удален' } } }
        }).catch((error) => {
            console.log(error)
        })
    },
    connectVkGroupToBot: (context, payload = { data: { group_id: null }, request: 'dont' }) => {
        axios.defaults.withCredentials = true
        return axios.get(
            constConf.user.url + '/connect_vk_groups'
        )
            .then((response) => {
                if (response.data.hasOwnProperty('success')) {
                    // context.commit('setBot', response.data.success.data)
                    return { success: { text: 'Группы успешно подключена!' } }
                } else {
                    return { error: { text: response.error.text } }
                }
            })
            .catch((error) => {
                console.log('Ошибка при группы')
                console.log(error)
            })
    },
    loadModerators: (context, botId) => {
        axios.defaults.withCredentials = true
        axios.get(constConf.bot.url + '/moderator/all/' + botId).then(response => {
            if (response.data.length !== 0) {
                context.commit('loadModerators', response.data)
            } else {
                context.commit('loadModerators', [])
            }
            // eslint-disable-next-line handle-callback-err
        }).catch((error) => {
            console.log('error get moderators ' + error)
        })
    },
    createModerator: (context, payload) => {
        axios.defaults.withCredentials = true
        return axios.post(constConf.bot.url + '/moderator/create', payload)
            .then(response => {
                if (response.data.hasOwnProperty('success')) {
                    context.commit('addModerator', response.data.success.data)
                }
                return response
            // eslint-disable-next-line handle-callback-err
            }).catch((error) => {
                console.log('error get moderators ' + error)
            })
    },
    removeModerator: (context, index) => {
        let payload = context.getters.moderators[index]
        axios({
            method: 'delete',
            url: constConf.bot.url + '/moderator/delete/' + payload.id
        })
            .then((response) => {
                context.commit('removeModerator', payload.id)
            })
            .catch((error) => {
                console.log('ошибка при записи значения')
                console.log(error)
            })
    },
    changeBotIdModelModeratorDefault: (context, botId) => {
        context.commit('changeBotIdModelModeratorDefault', botId)
    },
    setWebHookWa: (context, payload) => {
        axios.defaults.withCredentials = true
        return axios.get(constConf.bot.url + '/bot/set-web-hook-wa/' + payload.bot_id)
            .then(response => {
                // if (response.ok) {
                //     context.commit('setWebHookWa', response.data.response.data)
                // }
                return response.data
                // eslint-disable-next-line handle-callback-err
            }).catch((error) => {
                console.log('error get moderators ' + error)
            })
    }
}
